import { memo, useState } from 'react';

import { useSelector } from 'react-redux';

import { IState } from 'store';
import { IUFProps } from 'store/modules/config';

import Modal from 'components/common/Modal';
import ModalChangeState from 'components/common/Templates/ModalChangeState';

import * as S from './styles';

export function Region() {
  const ufSelected = useSelector<IState, IUFProps>(state => state.config.uf);

  const [showModalChangeState, setShowModalChangeState] = useState(false);

  return (
    <>
      <S.Container className="header-nav">
        <div className="header-nav-location">
          <img
            src="/images/icons/location.svg"
            alt="Local"
            className="icon location-icon"
          />

          <div>
            <p>Vendo preços para:</p>
            <div
              className="header-nav-location-info"
              onClick={() => setShowModalChangeState(true)}
            >
              <span>{ufSelected.value || 'SP'}</span>

              <span
                className="chevron-icon down white mb-2"
                title="Mostrar mais"
              />
            </div>
          </div>
        </div>
      </S.Container>

      {showModalChangeState && (
        <Modal onClose={() => setShowModalChangeState(false)}>
          <ModalChangeState setShowModalChangeState={setShowModalChangeState} />
        </Modal>
      )}
    </>
  );
}

export const MemoizedRegion = memo(Region);
